(function () {
  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isDesktop() {
    return window.matchMedia("(min-width: 800px)").matches;
  }

  function hero(root) {
    var idx = 0;
    var units = [];
    var track = qs(root, "[data-hero-track]");
    var frame = qs(root, ".embassy-hero__frame") || root;
    var dots = qs(root, "[data-hero-dots]");
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var autoplayMs = Math.max(0, Number(root.getAttribute("data-hero-autoplay") || 5)) * 1000;
    var timer = null;
    var hover = false;
    var wheelAcc = 0;
    var wheelLock = false;
    var pointerId = null;
    var dragStartX = 0;
    var dragging = false;
    var suppressClick = false;

    function collect() {
      if (root.getAttribute("data-hero-static") === "true") {
        units = qsa(root, "[data-hero-slide]");
        qsa(root, "[data-hero-tile], [data-hero-slide]").forEach(function (el) {
          el.hidden = false;
        });
        if (track) track.style.transform = "none";
        return;
      }
      if (isDesktop()) {
        units = qsa(root, "[data-hero-slide]");
        qsa(root, "[data-hero-tile]").forEach(function (tile) {
          tile.hidden = false;
        });
      } else {
        units = qsa(root, "[data-hero-tile]");
      }
      if (idx >= units.length) idx = 0;
    }

    function paintDots() {
      if (!dots) return;
      var buttons = qsa(dots, ".embassy-hero__dot");
      if (buttons.length !== units.length) {
        dots.innerHTML = "";
        units.forEach(function (_, i) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "embassy-hero__dot" + (i === idx ? " is-active" : "");
          b.setAttribute("aria-label", "Go to slide " + (i + 1));
          b.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            idx = i;
            paint();
            restartAuto();
          });
          dots.appendChild(b);
        });
        return;
      }
      buttons.forEach(function (b, i) {
        b.classList.toggle("is-active", i === idx);
      });
    }

    function paint() {
      if (!units.length) return;
      if (isDesktop() && track) {
        var w = frame.clientWidth || root.clientWidth;
        qsa(root, "[data-hero-slide]").forEach(function (el) {
          el.style.width = w + "px";
          el.style.minWidth = w + "px";
          el.style.flex = "0 0 " + w + "px";
        });
        track.style.transform = "translateX(" + -idx * w + "px)";
        qsa(root, "[data-hero-slide]").forEach(function (el) {
          el.hidden = false;
        });
        qsa(root, "[data-hero-tile]").forEach(function (el) {
          el.hidden = false;
        });
      } else {
        if (track) track.style.transform = "none";
        units.forEach(function (el, i) {
          el.hidden = i !== idx;
        });
      }
      paintDots();
    }

    function step(dir) {
      if (!units.length) return;
      idx = (idx + dir + units.length) % units.length;
      paint();
    }

    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAuto() {
      stopAuto();
      if (reduceMotion || autoplayMs < 1000 || units.length < 2 || hover || document.hidden) return;
      timer = window.setInterval(function () {
        step(1);
      }, autoplayMs);
    }

    function restartAuto() {
      stopAuto();
      startAuto();
    }

    collect();
    if (root.getAttribute("data-hero-static") === "true") {
      qsa(root, ".embassy-hero__arrow, .embassy-hero__dots").forEach(function (el) {
        el.hidden = true;
      });
      return;
    }
    paint();
    startAuto();

    var prev = qs(root, "[data-hero-prev]");
    var next = qs(root, "[data-hero-next]");
    if (prev) {
      prev.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        step(-1);
        restartAuto();
      });
    }
    if (next) {
      next.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        step(1);
        restartAuto();
      });
    }

    root.addEventListener("mouseenter", function () {
      hover = true;
      stopAuto();
    });
    root.addEventListener("mouseleave", function () {
      hover = false;
      startAuto();
    });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopAuto();
      else startAuto();
    });

    frame.addEventListener(
      "wheel",
      function (e) {
        var absX = Math.abs(e.deltaX);
        var absY = Math.abs(e.deltaY);
        if (absX < 6 || absX <= absY) return;
        e.preventDefault();
        if (wheelLock) return;
        wheelAcc += e.deltaX;
        if (Math.abs(wheelAcc) < 50) return;
        step(wheelAcc > 0 ? 1 : -1);
        wheelAcc = 0;
        wheelLock = true;
        window.setTimeout(function () {
          wheelLock = false;
        }, 420);
        restartAuto();
      },
      { passive: false }
    );

    root.addEventListener("dragstart", function (e) {
      e.preventDefault();
    });

    function beginDrag(x, ignore) {
      if (ignore) return;
      dragStartX = x;
      dragging = true;
      suppressClick = false;
    }
    function moveDrag(x) {
      if (!dragging) return;
      if (Math.abs(x - dragStartX) > 14) suppressClick = true;
    }
    function endDrag(x) {
      if (!dragging) return;
      var dx = x - dragStartX;
      dragging = false;
      pointerId = null;
      if (Math.abs(dx) > 50) {
        step(dx < 0 ? 1 : -1);
        restartAuto();
      }
    }
    function fromChrome(el) {
      return !!(el && el.closest && el.closest("[data-hero-prev], [data-hero-next], [data-hero-dots]"));
    }

    frame.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      if (fromChrome(e.target)) return;
      pointerId = e.pointerId;
      beginDrag(e.clientX);
      try {
        frame.setPointerCapture(e.pointerId);
      } catch (err) {}
    });
    frame.addEventListener("pointermove", function (e) {
      if (pointerId != null && e.pointerId !== pointerId) return;
      moveDrag(e.clientX);
    });
    frame.addEventListener("pointerup", function (e) {
      if (pointerId != null && e.pointerId !== pointerId) return;
      endDrag(e.clientX);
    });
    frame.addEventListener("pointercancel", function () {
      dragging = false;
      pointerId = null;
    });
    frame.addEventListener(
      "touchstart",
      function (e) {
        if (fromChrome(e.target) || !e.changedTouches[0]) return;
        beginDrag(e.changedTouches[0].clientX);
      },
      { passive: true }
    );
    frame.addEventListener(
      "touchmove",
      function (e) {
        if (!dragging || !e.changedTouches[0]) return;
        moveDrag(e.changedTouches[0].clientX);
      },
      { passive: true }
    );
    frame.addEventListener("touchend", function (e) {
      if (!e.changedTouches[0]) return;
      endDrag(e.changedTouches[0].clientX);
    });
    root.addEventListener(
      "click",
      function (e) {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      },
      true
    );

    window.addEventListener("resize", function () {
      collect();
      paint();
    });
  }

  function rail(root) {
    var track = qs(root, "[data-rail]");
    if (!track) return;
    if (root.getAttribute("data-rail-shuffle") === "true") {
      var nodes = Array.prototype.slice.call(track.children);
      var i;
      for (i = nodes.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = nodes[i];
        nodes[i] = nodes[j];
        nodes[j] = tmp;
      }
      nodes.forEach(function (node) { track.appendChild(node); });
    }
    var prev = qs(root, "[data-rail-prev]");
    var next = qs(root, "[data-rail-next]");
    function move(dir) {
      var w = track.clientWidth || 640;
      track.scrollBy({ left: dir * w, behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { move(-1); });
    if (next) next.addEventListener("click", function () { move(1); });
  }

  function pdpGallery(root) {
    var items = qsa(root, "[data-pdp-item]");
    if (!items.length) return;
    var idx = 0;
    var more = qs(root, "[data-pdp-more]");
    var pdp = root.closest(".embassy-pdp") || root;

    function pairSize() {
      return window.matchMedia("(min-width: 900px)").matches ? 2 : 1;
    }

    function normColor(value) {
      return String(value || "").toLowerCase().trim();
    }

    function visibleItems() {
      var color = normColor(pdp.getAttribute("data-active-color"));
      if (!color) return items;
      var matched = items.filter(function (el) {
        return normColor(el.getAttribute("data-color")) === color;
      });
      if (matched.length) return matched;
      var tagged = items.some(function (el) {
        return normColor(el.getAttribute("data-color"));
      });
      return tagged ? matched : items;
    }

    function paint() {
      var n = pairSize();
      var vis = visibleItems();
      if (!vis.length) {
        items.forEach(function (el) { el.hidden = true; });
        if (more) more.hidden = true;
        return;
      }
      if (idx >= vis.length) idx = 0;
      if (idx < 0) idx = 0;
      var windowIds = {};
      items.forEach(function (el) { el.hidden = true; });
      vis.forEach(function (el, i) {
        var on = i >= idx && i < idx + n;
        el.hidden = !on;
        if (on) windowIds[el.getAttribute("data-media-id")] = true;
      });
      if (!more) return;
      var shots = qsa(more, "[data-pdp-more-shot]");
      var rest = 0;
      shots.forEach(function (el) {
        var id = el.getAttribute("data-media-id");
        var inColor = vis.some(function (v) {
          return v.getAttribute("data-media-id") === id;
        });
        var hide = !inColor || !!windowIds[id];
        el.hidden = hide;
        if (!hide) rest += 1;
      });
      more.hidden = n === 1 || rest === 0;
    }

    function step(dir) {
      var n = pairSize();
      var vis = visibleItems();
      idx += dir * n;
      if (idx >= vis.length) idx = 0;
      if (idx < 0) idx = Math.max(0, vis.length - n);
      paint();
    }

    paint();
    var prev = qs(root, "[data-pdp-prev]");
    var next = qs(root, "[data-pdp-next]");
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    window.addEventListener("resize", paint);
    pdp.addEventListener("embassy:color", function () {
      idx = 0;
      paint();
    });
  }

  function pdpBuy(root) {
    var dataEl = qs(root, "[data-embassy-product]");
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var variants = data.variants || [];
    var selected = (data.options || []).map(function (name, i) {
      var current = variants[0] && variants[0].options ? variants[0].options[i] : "";
      var active = qs(root, '[data-option-index="' + i + '"].is-active');
      return active ? active.getAttribute("data-value") : current;
    });

    function findVariant() {
      return variants.find(function (v) {
        return (v.options || []).every(function (opt, i) {
          return !selected[i] || opt === selected[i];
        });
      });
    }

    function paint(v) {
      if (!v) return;
      var idInput = qs(root, 'input[name="id"]');
      if (idInput) idInput.value = v.id;
      var price = qs(root, "[data-pdp-price-value]");
      if (price && v.price_label) price.textContent = v.price_label;
      var stock = qs(root, "[data-pdp-stock]");
      if (stock) stock.textContent = v.available ? "In stock" : "Sold out";
      var stockRow = qs(root, "[data-pdp-stock-row]");
      if (stockRow) stockRow.classList.toggle("is-out", !v.available);
      var atc = qs(root, "[data-pdp-atc]");
      if (atc) atc.disabled = !v.available;
      var atcWrap = qs(root, "[data-pdp-atc-wrap]");
      var notify = qs(root, "[data-pdp-notify]");
      if (atcWrap) atcWrap.hidden = !v.available;
      if (notify) notify.hidden = !!v.available;
      var colorLabel = qs(root, "[data-pdp-color-label]");
      var colorIdx = data.options.findIndex(function (name) {
        return String(name).toLowerCase() === "color";
      });
      if (colorLabel && colorIdx >= 0 && selected[colorIdx]) {
        colorLabel.textContent = "COLOR: " + selected[colorIdx];
        var pdp = root.closest(".embassy-pdp");
        if (pdp) {
          pdp.setAttribute("data-active-color", selected[colorIdx]);
          pdp.dispatchEvent(new CustomEvent("embassy:color", { bubbles: true }));
        }
      }
      var sizeIdx = (data.options || []).findIndex(function (name) {
        return String(name).toLowerCase() === "size";
      });
      if (sizeIdx >= 0) {
        qsa(root, '[data-option-index="' + sizeIdx + '"]').forEach(function (btn) {
          var value = btn.getAttribute("data-value");
          var ok = variants.some(function (variant) {
            if (!variant.available) return false;
            return (variant.options || []).every(function (opt, i) {
              if (i === sizeIdx) return opt === value;
              return !selected[i] || String(opt) === String(selected[i]);
            });
          });
          btn.classList.toggle("is-unavailable", !ok);
        });
      }
    }

    qsa(root, "[data-option-index]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var i = Number(btn.getAttribute("data-option-index"));
        selected[i] = btn.getAttribute("data-value");
        qsa(root, '[data-option-index="' + i + '"]').forEach(function (el) {
          el.classList.toggle("is-active", el === btn);
        });
        paint(findVariant());
      });
    });
    paint(findVariant());
  }

  function trio(root) {
    var idx = 0;
    var units = [];
    var track = qs(root, "[data-trio-track]");
    var frame = qs(root, ".embassy-trio__frame") || root;
    var dots = qs(root, "[data-trio-dots]");
    var wheelAcc = 0;
    var wheelLock = false;

    function collect() {
      if (root.getAttribute("data-trio-static") === "true") {
        units = qsa(root, "[data-trio-slide]");
        qsa(root, "[data-trio-tile], [data-trio-slide]").forEach(function (el) {
          el.hidden = false;
        });
        if (track) track.style.transform = "none";
        return;
      }
      if (isDesktop()) {
        units = qsa(root, "[data-trio-slide]");
        qsa(root, "[data-trio-tile]").forEach(function (tile) {
          tile.hidden = false;
        });
      } else {
        units = qsa(root, "[data-trio-tile]");
      }
      if (idx >= units.length) idx = 0;
    }

    function paint() {
      if (!units.length) return;
      if (isDesktop() && track) {
        var w = frame.clientWidth || root.clientWidth;
        qsa(root, "[data-trio-slide]").forEach(function (el) {
          el.style.width = w + "px";
          el.style.minWidth = w + "px";
          el.style.flex = "0 0 " + w + "px";
        });
        track.style.transform = "translateX(" + -idx * w + "px)";
        qsa(root, "[data-trio-slide], [data-trio-tile]").forEach(function (el) {
          el.hidden = false;
        });
      } else {
        if (track) track.style.transform = "none";
        units.forEach(function (el, i) {
          el.hidden = i !== idx;
        });
      }
      if (!dots) return;
      dots.innerHTML = "";
      units.forEach(function (_, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "embassy-trio__dot" + (i === idx ? " is-active" : "");
        b.setAttribute("aria-label", "Go to slide " + (i + 1));
        b.addEventListener("click", function (e) {
          e.preventDefault();
          idx = i;
          paint();
        });
        dots.appendChild(b);
      });
    }

    function step(dir) {
      if (!units.length) return;
      idx = (idx + dir + units.length) % units.length;
      paint();
    }

    collect();
    if (root.getAttribute("data-trio-static") === "true") {
      qsa(root, ".embassy-trio__arrow, .embassy-trio__dots").forEach(function (el) {
        el.hidden = true;
      });
      return;
    }
    paint();
    var prev = qs(root, "[data-trio-prev]");
    var next = qs(root, "[data-trio-next]");
    if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); step(-1); });
    if (next) next.addEventListener("click", function (e) { e.preventDefault(); step(1); });
    frame.addEventListener(
      "wheel",
      function (e) {
        var absX = Math.abs(e.deltaX);
        var absY = Math.abs(e.deltaY);
        if (absX < 6 || absX <= absY) return;
        e.preventDefault();
        if (wheelLock) return;
        wheelAcc += e.deltaX;
        if (Math.abs(wheelAcc) < 50) return;
        step(wheelAcc > 0 ? 1 : -1);
        wheelAcc = 0;
        wheelLock = true;
        window.setTimeout(function () { wheelLock = false; }, 420);
      },
      { passive: false }
    );
    window.addEventListener("resize", function () {
      collect();
      paint();
    });
  }

  function collectionFilters(root) {
    var params = new URLSearchParams(window.location.search);
    var themeId = params.get("preview_theme_id");

    function keepTheme(href) {
      try {
        var url = new URL(href, window.location.origin);
        if (themeId) url.searchParams.set("preview_theme_id", themeId);
        return url.pathname + url.search;
      } catch (e) {
        return href;
      }
    }

    qsa(root, "a[href]").forEach(function (a) {
      a.setAttribute("href", keepTheme(a.getAttribute("href")));
    });

    qsa(root, "[data-filter-key]").forEach(function (a) {
      var key = a.getAttribute("data-filter-key");
      var value = a.getAttribute("data-filter-value") || "";
      var next = new URL(window.location.href);
      if (value) next.searchParams.set(key, value);
      else next.searchParams.delete(key);
      if (themeId) next.searchParams.set("preview_theme_id", themeId);
      a.setAttribute("href", next.pathname + next.search);
      if (value && params.get(key) === value) a.classList.add("is-active");
      if (!value && !params.get(key)) a.classList.add("is-active");
    });

    qsa(root, ".embassy-drop").forEach(function (drop) {
      drop.addEventListener("toggle", function () {
        if (!drop.open) return;
        qsa(root, ".embassy-drop").forEach(function (other) {
          if (other !== drop) other.open = false;
        });
      });
    });

    var size = (params.get("size") || "").toLowerCase();
    var color = (params.get("color") || "").toLowerCase();
    var material = (params.get("material") || "").toLowerCase();
    var category = (params.get("category") || "").toLowerCase();
    var sort = params.get("sort") || "";
    var grid = qs(document, ".embassy-collection__grid");
    var cards = qsa(document, ".embassy-collection__grid .embassy-card");
    var shown = 0;
    if (grid && grid.getAttribute("data-shuffle-collection") === "new-arrivals" && !sort) {
      cards = cards.slice();
      var i;
      for (i = cards.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = cards[i];
        cards[i] = cards[j];
        cards[j] = tmp;
      }
      cards.forEach(function (card) { grid.appendChild(card); });
    }
    if (sort === "price-asc" || sort === "price-desc") {
      cards = cards.slice().sort(function (a, b) {
        var pa = Number(a.getAttribute("data-price") || 0);
        var pb = Number(b.getAttribute("data-price") || 0);
        return sort === "price-asc" ? pa - pb : pb - pa;
      });
      if (grid) cards.forEach(function (card) { grid.appendChild(card); });
    }
    cards.forEach(function (card) {
      var ok = true;
      var sizes = (card.getAttribute("data-sizes") || "").toLowerCase();
      var colors = (card.getAttribute("data-colors") || "").toLowerCase();
      if (size) {
        var sizeHit = sizes.charAt(0) === "|" ? sizes.indexOf("|" + size + "|") !== -1 : sizes.indexOf(size) !== -1;
        if (!sizeHit) ok = false;
      }
      if (color) {
        var colorHit = colors.charAt(0) === "|" ? colors.indexOf("|" + color + "|") !== -1 : colors.indexOf(color) !== -1;
        if (!colorHit) ok = false;
      }
      if (material && (card.getAttribute("data-material") || "").toLowerCase().indexOf(material) === -1) ok = false;
      if (category && (card.getAttribute("data-category") || "").toLowerCase() !== category) ok = false;
      card.classList.toggle("embassy-collection__card-hidden", !ok);
      if (ok) shown += 1;
    });
    var count = qs(root, "[data-collection-count]");
    if (count && cards.length) count.textContent = shown + " products";
    var sortLabel = qs(root, "[data-collection-sort]");
    if (sortLabel) {
      sortLabel.textContent =
        sort === "price-asc" ? "Sort by: Low to high" :
        sort === "price-desc" ? "Sort by: High to low" :
        "Sort by: New in";
    }
  }

  function money(cents) {
    var value = (Number(cents) / 100).toFixed(2).replace(".", ",");
    return "€" + value;
  }

  function bagDrawer() {
    var root = qs(document, "[data-embassy-bag]");
    if (!root) return;
    var itemsEl = qs(root, "[data-embassy-bag-items]");
    var titleEl = qs(root, "[data-embassy-bag-title]");
    var subEl = qs(root, "[data-embassy-bag-subtotal]");
    var checkout = qs(root, "[data-embassy-bag-checkout]");
    var busy = false;

    function setOpen(open) {
      root.hidden = !open;
      document.body.style.overflow = open ? "hidden" : "";
    }

    function line(item) {
      var article = document.createElement("article");
      article.className = "embassy-bag__line";
      var media = document.createElement("a");
      media.className = "embassy-bag__media";
      media.href = item.url;
      if (item.image) {
        var img = document.createElement("img");
        img.src = item.image;
        img.alt = "";
        img.width = 72;
        img.height = 96;
        media.appendChild(img);
      }
      var info = document.createElement("div");
      info.className = "embassy-bag__info";
      var name = document.createElement("a");
      name.href = item.url;
      name.textContent = item.product_title || item.title || "";
      info.appendChild(name);
      if (item.variant_title && item.variant_title !== "Default Title") {
        var variant = document.createElement("p");
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }
      var qty = document.createElement("div");
      qty.className = "embassy-bag__qty";
      [["−", item.quantity - 1, "Decrease quantity"], ["+", item.quantity + 1, "Increase quantity"]].forEach(function (spec, index) {
        if (index === 1) {
          var count = document.createElement("span");
          count.textContent = String(item.quantity);
          qty.appendChild(count);
        }
        var btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = spec[0];
        btn.setAttribute("aria-label", spec[2]);
        btn.setAttribute("data-embassy-bag-qty", item.key);
        btn.setAttribute("data-qty", String(spec[1]));
        if (index === 0) qty.insertBefore(btn, qty.firstChild);
        else qty.appendChild(btn);
      });
      info.appendChild(qty);
      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "embassy-bag__remove";
      remove.textContent = "Remove";
      remove.setAttribute("data-embassy-bag-qty", item.key);
      remove.setAttribute("data-qty", "0");
      info.appendChild(remove);
      var price = document.createElement("p");
      price.className = "embassy-bag__price";
      price.textContent = money(item.final_line_price);
      article.appendChild(media);
      article.appendChild(info);
      article.appendChild(price);
      return article;
    }

    function paint(cart, added) {
      itemsEl.innerHTML = "";
      if (!cart.items || !cart.items.length) {
        var empty = document.createElement("p");
        empty.className = "embassy-bag__empty";
        empty.textContent = "Your bag is empty.";
        itemsEl.appendChild(empty);
      } else {
        cart.items.forEach(function (item) { itemsEl.appendChild(line(item)); });
      }
      if (titleEl) titleEl.textContent = added ? "Added to your bag" : "Your bag";
      if (subEl) subEl.textContent = money(cart.total_price || 0);
      if (checkout) checkout.disabled = !cart.item_count;
      qsa(document, "[data-embassy-bag-count]").forEach(function (el) {
        el.textContent = String(cart.item_count || 0);
      });
    }

    function refresh(added) {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { paint(cart, added); return cart; });
    }

    function change(key, qty) {
      if (busy) return;
      busy = true;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { paint(cart, false); })
        .catch(function () {})
        .then(function () { busy = false; });
    }

    qsa(document, "[data-embassy-bag-open]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        refresh(false).then(function () { setOpen(true); });
      });
    });
    qsa(root, "[data-embassy-bag-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { setOpen(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !root.hidden) setOpen(false);
    });
    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-embassy-bag-qty]");
      if (!btn) return;
      change(btn.getAttribute("data-embassy-bag-qty"), Number(btn.getAttribute("data-qty")));
    });

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
      if (form.getAttribute("data-embassy-native") === "1") return;
      e.preventDefault();
      fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          return refresh(true);
        })
        .then(function () { setOpen(true); })
        .catch(function () {
          form.setAttribute("data-embassy-native", "1");
          form.submit();
        });
    });
  }

  function searchPop() {
    var header = qs(document, "[data-embassy-header]");
    if (!header) return;
    var pop = qs(header, "[data-embassy-search-pop]");
    var input = qs(header, "[data-embassy-search-input]");
    var results = qs(header, "[data-embassy-search-results]");
    var form = pop ? qs(pop, "form") : null;
    if (!pop || !input || !results) return;
    var timer;
    var openBtn = qs(header, "[data-embassy-search]");

    function setOpen(open) {
      pop.hidden = !open;
      if (openBtn) openBtn.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) input.focus();
    }

    qsa(document, "[data-embassy-search]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(pop.hidden);
      });
    });

    document.addEventListener("click", function (e) {
      if (pop.hidden) return;
      if (e.target.closest("[data-embassy-search-pop], [data-embassy-search]")) return;
      setOpen(false);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setOpen(false);
    });

    function themeHref(href) {
      var theme = new URLSearchParams(window.location.search).get("preview_theme_id");
      if (!theme) return href;
      return href + (href.indexOf("?") >= 0 ? "&" : "?") + "preview_theme_id=" + encodeURIComponent(theme);
    }

    function run(q) {
      results.innerHTML = "";
      if (!q) return;
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          if (!products.length) {
            var empty = document.createElement("p");
            empty.className = "embassy-search-pop__empty";
            empty.textContent = "No products found.";
            results.appendChild(empty);
            return;
          }
          products.forEach(function (product) {
            var link = document.createElement("a");
            link.className = "embassy-search-hit";
            link.href = themeHref(product.url || ("/products/" + product.handle));
            var image = product.image || product.featured_image;
            if (image) {
              var img = document.createElement("img");
              img.src = image;
              img.alt = "";
              link.appendChild(img);
            }
            var name = document.createElement("span");
            name.textContent = product.title || "";
            link.appendChild(name);
            results.appendChild(link);
          });
        })
        .catch(function () {});
    }

    input.addEventListener("input", function () {
      window.clearTimeout(timer);
      var q = input.value.trim();
      timer = window.setTimeout(function () { run(q); }, 180);
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        run(input.value.trim());
      });
    }
  }

  qsa(document, "[data-embassy-hero]").forEach(hero);
  searchPop();
  bagDrawer();
  qsa(document, "[data-embassy-trio]").forEach(trio);
  qsa(document, "[data-embassy-filters]").forEach(collectionFilters);
  qsa(document, "[data-embassy-rail]").forEach(rail);
  qsa(document, "[data-pdp-gallery]").forEach(pdpGallery);
  qsa(document, "[data-pdp-buy]").forEach(pdpBuy);
})();
